import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpParams } from '@angular/common/http';
import { Subject } from 'rxjs';
import { CommonService } from '../../common.service';
import { NgxSpinnerService } from "ngx-spinner";
import { DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { CommonVariablesService } from '../../common-variables.service';
import { noop, Observable, Observer, of } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { from } from 'rxjs';

@Component({
  selector: 'app-detailed-report',
  templateUrl: './detailed-report.component.html',
  styleUrls: ['./detailed-report.component.css']
})
export class DetailedReportComponent implements OnInit {
  detailedReportForm: FormGroup;
  dtTrigger: Subject<any> = new Subject();
  dtOptions: any;
  tblData: any;
  submitted = false;
  dropdownSettings: IDropdownSettings = {};
  policyList: any;
  noResult = false;
  selected: string;
  voyageNameDropdownArr: any;
  responseFromDate: any;
  fromDate: any;
  toDate: any;
  policyCurrrencyType: any;
  certificateNumberStr: any;
  finalTblData: any;
  selectedPolicyData: Observable<any>;
  searchPolicyNumber: any;


  constructor(
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private commonVariablesService: CommonVariablesService,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe,
  ) { }

  ngOnInit() {
    this.selectedPolicyData = new Observable((observer: Observer<string>) => {
      observer.next(this.selected);

    })
      .pipe(
        switchMap((query: string) => {
          return from(this.loadPolicyData(query)).pipe(
            map((data: any) => data || []),
            tap(() => noop, err => { console.log('Something goes wrong'); })
          );
        })
      );
    window.localStorage.setItem('pageName', '');
    $("#divDetailedReport").hide();
    $("#btnDetailedReportExcelDownload").hide();

    this.detailedReportForm = this.formBuilder.group({
      txtPolicyNo: ['', Validators.required],
      txtFromDate: ['', Validators.required],
      txtToDate: ['', Validators.required],
      selVoyageName: ['', Validators.required],
    });

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'voyage_id',
      textField: 'voyage_name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 5,
      allowSearchFilter: true
    };

    this.dtOptions = {
      dom: 'frtip',
      "pageLength": 50
    };

    // this.loadPolicyData();
  }

  /*******************************************
  * Created By : Dinesh kumar
  * Description : Used to get form controls.
  ********************************************/
  get f() { return this.detailedReportForm.controls; }

  /*******************************************
  * Created By : Dinesh kumar
  * Description : Used to fetch policy list.
  ********************************************/
  async loadPolicyData(policyNo) {
    this.searchPolicyNumber = policyNo;

    if (policyNo.length >= 6) {
      let url = this.commonVariablesService.baseURL + 'api/v1/marine_report/policy_list';
      let params = {
        policy_no: policyNo,

      }
      let responseData = await this.commonService.httpGetMethod(url, '', true, params, "Detailed Report");
      this.policyList = [];

      if (responseData.status == 0) {
        for (let count = 0; count < responseData.data.length; count++) {
          this.policyList.push(responseData.data[count]);
        }
      }
      else if (responseData.status != -114) {
        this.commonService.errorsmsg('Fetch Error: ' + responseData.txt, 'Error');
      }

      if (this.policyList.length > 0) {
        this.policyList.forEach((obj, index) => {
          obj["search_val"] = (obj.policy_number || '');
        });
      }
      return this.policyList;
    }

  }

  /*******************************************
  * Created By : Dinesh kumar
  * Description : Used to show no result found.
  ********************************************/
  typeaheadNoResults(event: boolean) {
    if (this.searchPolicyNumber.length >= 6) {
      this.noResult = event;
    }
  }

  /*****************************************************
  * Created By : Dinesh kumar
  * Description : Used to get selected policy list data.
  *******************************************************/
  typeaheadOnSelect(e: any) {
    this.voyageNameDropdownArr = [];
    this.selected = e.value ? e.value : "";
    this.fromDate = new Date(e.item.policy_inception_date);
    this.toDate = new Date(e.item.policy_expiry_date);
    var voyageArr = [];
    voyageArr = (e.item.voyage_name).split(',');
    this.responseFromDate = new Date(e.item.policy_inception_date);
    this.responseFromDate = (this.responseFromDate).setHours(0, 0, 0, 0);
    this.policyCurrrencyType = e.item.policy_currency_type;

    if (voyageArr.length > 0) {
      this.voyageNameDropdownArr = voyageArr;
    }

    this.detailedReportForm.patchValue({
      txtFromDate: this.fromDate,
      txtToDate: this.toDate,
      selVoyageName: voyageArr
    });
  }

  /********************************************************************
  * Created By : Dinesh kumar
  * Description : Used to show the data against from date and to date.
  *********************************************************************/
  async submitDate() {
    if (this.detailedReportForm.invalid) {
      this.submitted = true;
      return;
    }
    else {
      var tmpFrom = this.detailedReportForm.value.txtFromDate;
      var tmpTo = this.detailedReportForm.value.txtToDate;
      tmpFrom = tmpFrom.setHours(0, 0, 0, 0);
      tmpTo = tmpTo.setHours(0, 0, 0, 0
      );

      if (new Date(this.responseFromDate) > new Date(tmpFrom)) {
        this.commonService.errorsmsg("From date should not be less than " + this.datePipe.transform(this.responseFromDate, 'dd-MM-yyyy'), "Error");
      }
      else if (new Date(this.responseFromDate) > new Date(tmpTo)) {
        this.commonService.errorsmsg("To date should not be less than " + this.datePipe.transform(this.responseFromDate, 'dd-MM-yyyy'), "Error");
      }
      else if (new Date(tmpTo) < new Date(tmpFrom)) {
        this.commonService.errorsmsg("To date should not be less than From date", "Error");
      }
      else {
        this.spinner.show();
        let fetchUrl = this.commonVariablesService['baseURL'] + 'api/v1/marine_report/fetch_detailed';
        this.tblData = [];
        this.finalTblData = [];
        let voyage_name = this.detailedReportForm.value.selVoyageName;
        var voyageStr = '', certificateNumberStr = '';

        for (let name of voyage_name) {
          voyageStr += name + ",";
        }

        voyageStr = voyageStr.substring(0, voyageStr.length - 1);
        let table = $('#tblDetailedReportForm').DataTable();
        table.destroy();
        let param = new HttpParams().set('from_date', this.datePipe.transform(tmpFrom, 'yyyy-MM-dd'))
          .set('to_date', this.datePipe.transform(tmpTo, 'yyyy-MM-dd'))
          .set('policy_no', this.detailedReportForm.value.txtPolicyNo)
          .set('voyage_name', voyageStr);
        let responseData = await this.commonService.httpGetMethod(fetchUrl, 'application/x-www-form-urlencoded', true, param, 'Detailed Report');

        if (responseData.status == 0) {
          for (let count = 0; count < responseData.data.length; count++) {
            this.finalTblData.push(responseData.data[count]);
            // certificateNumberStr += responseData.data[count].certificate_no + ',';
          }

          //certificateNumberStr = (certificateNumberStr).substring(0, (certificateNumberStr).length - 1);
          //this.getCancelCertificateData(certificateNumberStr);
          //this.finalTblData = this.tblData;
          this.dtTrigger.next();
          $("#divDetailedReport").show();
          $("#btnDetailedReportExcelDownload").show();
        }
        else if (responseData.status != -114) {
          this.commonService.errorsmsg('Fetch Error: ' + responseData.txt, "Error");
        }
      }
    }
  }

  /***************************************************************
  * Created By : Dinesh kumar
  * Description : Used to get cancel certificate reason & time.
  ****************************************************************/
  async getCancelCertificateData(certificateNo) {
    let table = $('#tblDetailedReportForm').DataTable();
    table.destroy();

    if (certificateNo != '') {
      this.spinner.show();
      let fetchUrl = this.commonVariablesService['baseURL'] + 'api/v1/marine_report/policy_list/cancel_certificate';
      let param = new HttpParams().set('certificate_no', certificateNo);
      let responseData = await this.commonService.httpGetMethod(fetchUrl, 'application/x-www-form-urlencoded', true, param, 'Detailed Report');
      var certificateArr = [];
      this.finalTblData = [];

      if (responseData.status == 0) {
        for (let count = 0; count < responseData.data.length; count++) {
          certificateArr.push(responseData.data[count]);
        }
      }
      else if (responseData.status != -114) {
        this.commonService.errorsmsg('Fetch Error: ' + responseData.txt, "Error");
      }

      if (this.tblData.length > 0 && certificateArr.length > 0) {
        for (let tblDataCount = 0; tblDataCount < this.tblData.length; tblDataCount++) {
          for (let Count = 0; Count < certificateArr.length; Count++) {
            if (this.tblData[tblDataCount].certificate_no == certificateArr[Count].cert_policy_no) {
              this.tblData[tblDataCount].uw_name_cancel = certificateArr[Count].actioned_by;
              this.tblData[tblDataCount].cancel_remark = certificateArr[Count].comments;
              this.tblData[tblDataCount].cert_cancel_status = certificateArr[Count].cancel_status;
              this.tblData[tblDataCount].cert_cancel_date = certificateArr[Count].u_ts;
            }
          }
        }
      }
    }

    this.finalTblData = this.tblData;
    this.dtTrigger.next();

    $("#divDetailedReport").show();
    $("#btnDetailedReportExcelDownload").show();
  }

  /***************************************
  * Created By : Dinesh kumar
  * Description : Used to download excel.
  ****************************************/
  exportExcel() {
    if (this.finalTblData.length > 0) {
      var jsonData = { excelData: this.finalTblData }, voyageNameForExcel = '';

      for (let name of this.detailedReportForm.value.selVoyageName) {
        voyageNameForExcel += name + ",";
      }

      voyageNameForExcel = voyageNameForExcel.substring(0, voyageNameForExcel.length - 1);

      var Heading = [
        [],
        ["Detailed Report"],
        [],
        ["Policy Number", this.detailedReportForm.value.txtPolicyNo],
        ["From Date", this.datePipe.transform(this.detailedReportForm.value.txtFromDate, 'dd-MM-yyyy')],
        ["To Date", this.datePipe.transform(this.detailedReportForm.value.txtToDate, 'dd-MM-yyyy')],
        ["Voyage Name", voyageNameForExcel],
        [],
        ["Certificate Number / Draft Number", "Policy Number", "Insured Name", "Address 1", "Address 2", "Address 3", "GSTIN", "Country", "Pincode", "State", "City", "District", "New Clients", "Voyage Name", "Mode of Shipment", "Coverage", "Packing", "From Country", "To Country", "From-City", "Origin text to appear on certificate", "To-City", "Origin text to appear on certificate2", "Invoice currency Type*", "Cargo value as per Invoice currency", "Cargo Sum Insured in invoice currency", "ROE (Rate of exchange)", "Cargo Sum insured Value in " + this.policyCurrrencyType, "Duty Sum Insured in INR", "Total Sum Insured in " + this.policyCurrrencyType, "Cargo Premium in " + this.policyCurrrencyType, "Duty Premium in " + this.policyCurrrencyType, "Total Premium in " + this.policyCurrrencyType, "Non-Standard Clauses", "Marine Final Rate", "Expected date of shipment", "Bill of Lading Number/Airway Bill Number", "Bill of Lading Date/Airway Bill Date", "Letter of Credit Number", "Letter of Credit Description/Special Terms", "Place of Issuance", "Invoice Number", "Invoice Date", "Subject Matter Insured", "Marks & Numbers", "Vessel Name or Flight Number/Airline", "Consignee Name", "Consignee Address", "Financier Name", "Issue Date*", "Claims Payable at*", "Settling Agent*", "Claims Representative*", "Reason for change", "Field to be change", "Underwriter Name(who has approved/rejected referral)", "Underwriter Name(who has approved certifcate cancellation)", "Underwriter Remark", "Cancellation Remark", "Referral status", "Certificate Cancellation status", "Referral approve/reject date and timestamp", "Certificate Cancellation date and timestamp"]
      ];

      const merge = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: 62 } },
        { s: { r: 1, c: 0 }, e: { r: 1, c: 62 } },
        { s: { r: 2, c: 0 }, e: { r: 2, c: 62 } },
        { s: { r: 3, c: 0 }, e: { r: 3, c: 62 } },
        { s: { r: 8, c: 0 }, e: { r: 8, c: 62 } }
      ];
      var wscols = [];

      for (let i = 0; i < Heading[8].length; i++) {
        wscols.push({ wch: 25 });  // Common column width
      }

      var ws = XLSX.utils.json_to_sheet(Heading);
      ws['!cols'] = wscols;
      ws["!merges"] = merge;
      ws["A1"] = {
        "t": 's',
        /* "v": 'TATA MARINE' */
      };

      XLSX.utils.sheet_add_json(ws, jsonData.excelData, {
        header: ["certificate_no", "policy_no", "insured_name", "client_address_1", "client_address_2", "client_address_3", "client_gstin", "client_country", "client_pincode", "client_state", "client_city", "client_district", "add_new_client", "voyage_name", "mode_of_conveyance", "coverage_type", "packing", "from_country", "to_country", "from_city", "Origin_certificate", "to_city", "Origin_certificate2", "invoice_currency", "cargo_value", "cargo_si", "roe", "cargo_si_policy_currency", "duty_si", "total_si", "cargo_premium", "duty_premium", "net_premium_final", "non_std_clauses", "pol_marine_rate", "expected_date_shipment", "bill_no", "bill_date", "lc_no", "lc_details", "issuance_place", "invoice_no", "invoice_date", "subject_matter_insured", "marks_numbers", "vessel_name", "consignee_name", "consignee_address", "financier_name", "issue_date", "claims_payable_at", "settling_agent", "claims_rep", "reason_change", "fields_to_change", "uw_name_appr", "uw_name_cancel", "uw_remark", "cancel_remark", "referral_status", "cert_cancel_status", "referral_approve_date", "cert_cancel_date"],
        skipHeader: true,
        origin: -1
      });

      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Detailed Report");
      XLSX.writeFile(wb, 'Detailed_Report.xlsx');
    }
    else {
      this.commonService.errorsmsg("Unable to download excel,No data available in the table", "Error");
    }
  }

  /**********************************************
  * Created By : Keerthana
  * Description : Used to do search in datatable.
  ***********************************************/
  filterBySearch() {
    let searchCertificateNo = $("#searchCertificateNo").val().toString().toLowerCase();
    let searchPolicyNo = $("#searchPolicyNo").val().toString().toLowerCase();
    let searchInsuredName = $("#searchInsuredName").val().toString().toLowerCase();
    let searchAddress1 = $("#searchAddress1").val().toString().toLowerCase();
    let searchAddress2 = $("#searchAddress2").val().toString().toLowerCase();
    let searchAddress3 = $("#searchAddress3").val().toString().toLowerCase();
    let searchGSTIN = $("#searchGSTIN").val().toString().toLowerCase();
    let searchCountry = $("#searchCountry").val().toString().toLowerCase();
    let searchPincode = $("#searchPincode").val().toString().toLowerCase();
    let searchState = $("#searchState").val().toString().toLowerCase();
    let searchCity = $("#searchCity").val().toString().toLowerCase();
    let searchDistrict = $("#searchDistrict").val().toString().toLowerCase();
    let searchNewClients = $("#searchNewClients").val().toString().toLowerCase();
    let searchVoyageName = $("#searchVoyageName").val().toString().toLowerCase();
    let searchModeOfShipment = $("#searchModeOfShipment").val().toString().toLowerCase();
    let searchCoverage = $("#searchCoverage").val().toString().toLowerCase();
    let searchPacking = $("#searchPacking").val().toString().toLowerCase();
    let searchFromCountry = $("#searchFromCountry").val().toString().toLowerCase();
    let searchToCountry = $("#searchToCountry").val().toString().toLowerCase();
    let searchFromCity = $("#searchFromCity").val().toString().toLowerCase();
    let searchOriginTextCertificate1 = $("#searchOriginTextCertificate1").val().toString().toLowerCase();
    let searchToCity = $("#searchToCity").val().toString().toLowerCase();
    let searchOriginTextCertificate2 = $("#searchOriginTextCertificate2").val().toString().toLowerCase();
    let searchInvoiceCurrencyType = $("#searchInvoiceCurrencyType").val().toString().toLowerCase();
    let searchCargoValue = $("#searchCargoValue").val().toString().toLowerCase();
    let searchCargoSumInsured = $("#searchCargoSumInsured").val().toString().toLowerCase();
    let searchROE = $("#searchROE").val().toString().toLowerCase();
    let searchCargoSumInsuredValueIn = $("#searchCargoSumInsuredValueIn").val().toString().toLowerCase();
    let searchDutySumInsuredIn = $("#searchDutySumInsuredIn").val().toString().toLowerCase();
    let searchTotalSumInsuredIn = $("#searchTotalSumInsuredIn").val().toString().toLowerCase();
    let searchCargoPremiumIn = $("#searchCargoPremiumIn").val().toString().toLowerCase();
    let searchDutyPremiumIn = $("#searchDutyPremiumIn").val().toString().toLowerCase();
    let searchTotalPremiumIn = $("#searchTotalPremiumIn").val().toString().toLowerCase();
    let searchNonStandardClauses = $("#searchNonStandardClauses").val().toString().toLowerCase();
    let searchMarineFinalRate = $("#searchMarineFinalRate").val().toString().toLowerCase();
    let searchExpectedDateOfShipment = $("#searchExpectedDateOfShipment").val().toString().toLowerCase();
    let searchAirwayBillNo = $("#searchAirwayBillNo").val().toString().toLowerCase();
    let searchAirwayBillDate = $("#searchAirwayBillDate").val().toString().toLowerCase();
    let searchLetterOfCreditNumber = $("#searchLetterOfCreditNumber").val().toString().toLowerCase();
    let searchLetterOfCreditDescription = $("#searchLetterOfCreditDescription").val().toString().toLowerCase();
    let searchPlaceOfIssuance = $("#searchPlaceOfIssuance").val().toString().toLowerCase();
    let searchInvoiceNumber = $("#searchInvoiceNumber").val().toString().toLowerCase();
    let searchInvoiceDate = $("#searchInvoiceDate").val().toString().toLowerCase();
    let searchSubjectMatterInsured = $("#searchSubjectMatterInsured").val().toString().toLowerCase();
    let searchMarkAndNumbers = $("#searchMarkAndNumbers").val().toString().toLowerCase();
    let searchVesselName = $("#searchVesselName").val().toString().toLowerCase();
    let searchConsigneeName = $("#searchConsigneeName").val().toString().toLowerCase();
    let searchConsigneeAddress = $("#searchConsigneeAddress").val().toString().toLowerCase();
    let searchFinancierName = $("#searchFinancierName").val().toString().toLowerCase();
    let searchIssueDate = $("#searchIssueDate").val().toString().toLowerCase();
    let searchClaimsPayableAt = $("#searchClaimsPayableAt").val().toString().toLowerCase();
    let searchSettlingAgent = $("#searchSettlingAgent").val().toString().toLowerCase();
    let searchClaimsRepresentative = $("#searchClaimsRepresentative").val().toString().toLowerCase();
    let searchReasonForChange = $("#searchReasonForChange").val().toString().toLowerCase();
    let searchFieldToChange = $("#searchFieldToChange").val().toString().toLowerCase();
    let searchRejectedUnderwriterName = $("#searchRejectedUnderwriterName").val().toString().toLowerCase();
    let searchApprovedUnderwriterName = $("#searchApprovedUnderwriterName").val().toString().toLowerCase();
    let searchUnderwriterRemark = $("#searchUnderwriterRemark").val().toString().toLowerCase();
    let searchCancellationRemark = $("#searchCancellationRemark").val().toString().toLowerCase();
    let searchReferralStatus = $("#searchReferralStatus").val().toString().toLowerCase();
    let searchCertificateCancellationStatus = $("#searchCertificateCancellationStatus").val().toString().toLowerCase();
    let searchReferralApprove = $("#searchReferralApprove").val().toString().toLowerCase();
    let searchCertificateCancellation = $("#searchCertificateCancellation").val().toString().toLowerCase();


    let table = $("#tblDetailedReportForm").DataTable();
    table.search('').columns().search('').draw();
    if (searchCertificateNo != "") {
      table.column(0).search(searchCertificateNo).draw();
    }
    if (searchPolicyNo != "") {
      table.column(1).search(searchPolicyNo).draw();
    }
    if (searchInsuredName != "") {
      table.column(2).search(searchInsuredName).draw();
    }
    if (searchAddress1 != "") {
      table.column(3).search(searchAddress1).draw();
    }
    if (searchAddress2 != "") {
      table.column(4).search(searchAddress2).draw();
    }
    if (searchAddress3 != "") {
      table.column(5).search(searchAddress3).draw();
    }
    if (searchGSTIN != "") {
      table.column(6).search(searchGSTIN).draw();
    }
    if (searchCountry != "") {
      table.column(7).search(searchCountry).draw();
    }
    if (searchPincode != "") {
      table.column(8).search(searchPincode).draw();
    }
    if (searchState != "") {
      table.column(9).search(searchState).draw();
    }
    if (searchCity != "") {
      table.column(10).search(searchCity).draw();
    }
    if (searchDistrict != "") {
      table.column(11).search(searchDistrict).draw();
    }
    if (searchNewClients != "") {
      table.column(12).search(searchNewClients).draw();
    }
    if (searchVoyageName != "") {
      table.column(13).search(searchVoyageName).draw();
    }
    if (searchModeOfShipment != "") {
      table.column(14).search(searchModeOfShipment).draw();
    }
    if (searchCoverage != "") {
      table.column(15).search(searchCoverage).draw();
    }
    if (searchPacking != "") {
      table.column(16).search(searchPacking).draw();
    }
    if (searchFromCountry != "") {
      table.column(17).search(searchFromCountry).draw();
    }
    if (searchToCountry != "") {
      table.column(18).search(searchToCountry).draw();
    }
    if (searchFromCity != "") {
      table.column(19).search(searchFromCity).draw();
    }
    if (searchOriginTextCertificate1 != "") {
      table.column(20).search(searchOriginTextCertificate1).draw();
    }
    if (searchToCity != "") {
      table.column(21).search(searchToCity).draw();
    }
    if (searchOriginTextCertificate2 != "") {
      table.column(22).search(searchOriginTextCertificate2).draw();
    }
    if (searchInvoiceCurrencyType != "") {
      table.column(23).search(searchInvoiceCurrencyType).draw();
    }
    if (searchCargoValue != "") {
      table.column(24).search(searchCargoValue).draw();
    }
    if (searchCargoSumInsured != "") {
      table.column(25).search(searchCargoSumInsured).draw();
    }
    if (searchROE != "") {
      table.column(26).search(searchROE).draw();
    }
    if (searchCargoSumInsuredValueIn != "") {
      table.column(27).search(searchCargoSumInsuredValueIn).draw();
    }
    if (searchDutySumInsuredIn != "") {
      table.column(28).search(searchDutySumInsuredIn).draw();
    }
    if (searchTotalSumInsuredIn != "") {
      table.column(29).search(searchTotalSumInsuredIn).draw();
    }
    if (searchCargoPremiumIn != "") {
      table.column(30).search(searchCargoPremiumIn).draw();
    }
    if (searchDutyPremiumIn != "") {
      table.column(31).search(searchDutyPremiumIn).draw();
    }
    if (searchTotalPremiumIn != "") {
      table.column(32).search(searchTotalPremiumIn).draw();
    }
    if (searchNonStandardClauses != "") {
      table.column(33).search(searchNonStandardClauses).draw();
    }
    if (searchMarineFinalRate != "") {
      table.column(34).search(searchMarineFinalRate).draw();
    }
    if (searchExpectedDateOfShipment != "") {
      table.column(35).search(searchExpectedDateOfShipment).draw();
    }
    if (searchAirwayBillNo != "") {
      table.column(36).search(searchAirwayBillNo).draw();
    }
    if (searchAirwayBillDate != "") {
      table.column(37).search(searchAirwayBillDate).draw();
    }
    if (searchLetterOfCreditNumber != "") {
      table.column(38).search(searchLetterOfCreditNumber).draw();
    }
    if (searchLetterOfCreditDescription != "") {
      table.column(39).search(searchLetterOfCreditDescription).draw();
    }
    if (searchPlaceOfIssuance != "") {
      table.column(40).search(searchPlaceOfIssuance).draw();
    }
    if (searchInvoiceNumber != "") {
      table.column(41).search(searchInvoiceNumber).draw();
    }
    if (searchInvoiceDate != "") {
      table.column(42).search(searchInvoiceDate).draw();
    }
    if (searchSubjectMatterInsured != "") {
      table.column(43).search(searchSubjectMatterInsured).draw();
    }
    if (searchMarkAndNumbers != "") {
      table.column(44).search(searchMarkAndNumbers).draw();
    }
    if (searchVesselName != "") {
      table.column(45).search(searchVesselName).draw();
    }
    if (searchConsigneeName != "") {
      table.column(46).search(searchConsigneeName).draw();
    }
    if (searchConsigneeAddress != "") {
      table.column(47).search(searchConsigneeAddress).draw();
    }
    if (searchFinancierName != "") {
      table.column(48).search(searchFinancierName).draw();
    }
    if (searchIssueDate != "") {
      table.column(49).search(searchIssueDate).draw();
    }
    if (searchClaimsPayableAt != "") {
      table.column(50).search(searchClaimsPayableAt).draw();
    }
    if (searchSettlingAgent != "") {
      table.column(51).search(searchSettlingAgent).draw();
    }
    if (searchClaimsRepresentative != "") {
      table.column(52).search(searchClaimsRepresentative).draw();
    }
    if (searchReasonForChange != "") {
      table.column(53).search(searchReasonForChange).draw();
    }
    if (searchFieldToChange != "") {
      table.column(54).search(searchFieldToChange).draw();
    }
    if (searchRejectedUnderwriterName != "") {
      table.column(55).search(searchRejectedUnderwriterName).draw();
    }
    if (searchApprovedUnderwriterName != "") {
      table.column(56).search(searchApprovedUnderwriterName).draw();
    }
    if (searchUnderwriterRemark != "") {
      table.column(57).search(searchUnderwriterRemark).draw();
    }
    if (searchCancellationRemark != "") {
      table.column(58).search(searchCancellationRemark).draw();
    }
    if (searchReferralStatus != "") {
      table.column(59).search(searchReferralStatus).draw();
    }
    if (searchCertificateCancellationStatus != "") {
      table.column(60).search(searchCertificateCancellationStatus).draw();
    }
    if (searchReferralApprove != "") {
      table.column(61).search(searchReferralApprove).draw();
    }
    if (searchReferralApprove != "") {
      table.column(62).search(searchCertificateCancellation).draw();
    }

  }

}
